"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_84_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * map SystemRef to EchainSystem and
 * remove SystemRef
 */
const migration_84_0_0 = (json) => {
    var _a;
    if (json.Kette && json.Kette.SystemRef) {
        if ((_a = json.Kette.SystemRef) === null || _a === void 0 ? void 0 : _a.Kuerzel) {
            json.Kette.EchainSystem = (0, echain_shared_articles_1.echainSystemFromIproSystemRefKuerzel)(json.Kette.SystemRef.Kuerzel);
        }
        delete json.Kette.SystemRef;
    }
    return json;
};
exports.migration_84_0_0 = migration_84_0_0;
//# sourceMappingURL=migration_84_0_0.js.map